<script>
  import * as _ from "lodash";
  var script = document.createElement("script");
  script.src = "//translate.google.com/translate_a/element.js?cb=initGoogleTranslate";
  const env = window["C"]?.env;
  if (env && env !== "test") {
    document.body.appendChild(script);
    setTimeout(function () {
      if (
        typeof google !== "undefined" &&
        _.get(google, "translate.TranslateElement.InlineLayout")
      ) {
        new google.translate.TranslateElement(
          {
            pageLanguage: "en",
            layout: google.translate.TranslateElement.InlineLayout.HORIZONTAL,
            gaTrack: true,
            gaId: "UA-98515154-1",
          },
          "google_translate_element"
        );
      }
    }, 1000);
  }

</script>

<div id="google_translate_element" />
